import { request } from '../../Common/api/client';

const DEFAULT_SEARCH_ENDPOINT = '/api/cp/gasystem/payment-customers';

export async function searchGasystemCpPaymentCustomers(params = {}, configuredEndpoint) {
  const endpoint = String(configuredEndpoint || '').trim();
  const url = endpoint.startsWith('/api/cp/gasystem/')
    ? endpoint
    : DEFAULT_SEARCH_ENDPOINT;
  const query = {
    page: params.page || 1,
    limit: params.limit || 100,
  };
  const q = String(params.q || '').trim();
  const businessNo = String(params.businessNo || '').replace(/\D/g, '');
  if (q) query.q = q;
  if (businessNo) query.businessNo = businessNo;
  return request({ method: 'GET', url, params: query });
}

export async function submitGasystemCpManualPayment(payload) {
  return request({
    method: 'POST',
    url: '/api/cp/payment/manual',
    data: payload,
  });
}
